const mainTheme = { url: "/assets/music/music_main_theme_loop.mp3" };
const lessonBed = { url: "/assets/music/music_lesson_bed_loop.mp3" };
const infographicFocus = { url: "/assets/music/music_infographic_focus_loop.mp3" };
const quizFocus = { url: "/assets/music/music_quiz_focus_loop.mp3" };
const parentDashboard = { url: "/assets/music/music_parent_dashboard_loop.mp3" };
const reflectionState = { url: "/assets/music/music_reflection_state_loop.mp3" };
const moduleMissionStart = { url: "/assets/music/music_module_mission_start.mp3" };
const decisionPoint = { url: "/assets/music/music_decision_point_loop.mp3" };
const creditSignal = { url: "/assets/music/music_credit_signal_loop.mp3" };
const scamSignal = { url: "/assets/music/music_scam_signal_loop.mp3" };
const simWalletFlow = { url: "/assets/music/music_sim_wallet_flow_loop.mp3" };
const moduleCompletion = { url: "/assets/music/music_module_completion_loop.mp3" };

export type MusicKey =
  | "mainTheme"
  | "lessonBed"
  | "infographicFocus"
  | "quizFocus"
  | "parentDashboard"
  | "reflectionState"
  | "moduleMissionStart"
  | "decisionPoint"
  | "creditSignal"
  | "scamSignal"
  | "simWalletFlow"
  | "moduleCompletion";

export interface MusicEntry {
  url: string;
  loop: boolean;
  /** Per-track default volume (0..1). Master volume multiplies this. */
  defaultVolume: number;
  fadeInMs: number;
  fadeOutMs: number;
}

export const musicMap: Record<MusicKey, MusicEntry> = {
  mainTheme:          { url: mainTheme.url,          loop: true,  defaultVolume: 0.10, fadeInMs: 1200, fadeOutMs: 1000 },
  lessonBed:          { url: lessonBed.url,          loop: true,  defaultVolume: 0.11, fadeInMs: 1400, fadeOutMs: 1200 },
  infographicFocus:   { url: infographicFocus.url,   loop: true,  defaultVolume: 0.07, fadeInMs: 1400, fadeOutMs: 1200 },
  quizFocus:          { url: quizFocus.url,          loop: true,  defaultVolume: 0.09, fadeInMs: 1200, fadeOutMs: 1000 },
  parentDashboard:    { url: parentDashboard.url,    loop: true,  defaultVolume: 0.07, fadeInMs: 1400, fadeOutMs: 1200 },
  reflectionState:    { url: reflectionState.url,    loop: true,  defaultVolume: 0.09, fadeInMs: 1200, fadeOutMs: 1200 },
  moduleMissionStart: { url: moduleMissionStart.url, loop: false, defaultVolume: 0.17, fadeInMs: 600,  fadeOutMs: 1200 },
  decisionPoint:      { url: decisionPoint.url,      loop: true,  defaultVolume: 0.12, fadeInMs: 800,  fadeOutMs: 1000 },
  creditSignal:       { url: creditSignal.url,       loop: true,  defaultVolume: 0.13, fadeInMs: 1000, fadeOutMs: 1000 },
  scamSignal:         { url: scamSignal.url,         loop: true,  defaultVolume: 0.13, fadeInMs: 1000, fadeOutMs: 1000 },
  simWalletFlow:      { url: simWalletFlow.url,      loop: true,  defaultVolume: 0.12, fadeInMs: 1000, fadeOutMs: 1000 },
  moduleCompletion:   { url: moduleCompletion.url,   loop: false, defaultVolume: 0.15, fadeInMs: 400,  fadeOutMs: 1200 },
};